import {
    Box,
    Typography,
    Grid,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

export const SMAppSalesStatistics: React.FC = () => {
    const { t } = useTranslation()

    const data = [
        {
            'sales': '5',
            'des': t('t108')
        },
        {
            'sales': '400',
            'des': t('t109')
        },
        {
            'sales': '100',
            'des': t('t110')
        },
        {
            'sales': '200k',
            'des': t('t111')
        }
    ]

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Box sx={{
                backgroundColor: '#0D1720',
                width: '100%',
                paddingTop: '60px',
                paddingBottom: '60px',
                borderRadius: '10px',
            }}>
                <Grid container height={'100%'} rowSpacing={10}>
                    {data.map((item, index) => (
                        <Grid item key={index} xs={12} alignItems={'center'} justifyContent={'center'} height={'100%'}>
                            <Box sx={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Typography fontSize={55} fontWeight={600} color={'#FFFFFF'}>
                                    {data[index]['sales']}
                                    <span style={{ fontSize: '40px', color: '#FFFFFF' }}>+</span>
                                </Typography>
                                <Typography fontSize={16} fontWeight={400} color={'#FFFFFF'}>
                                    {data[index]['des']}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>

        </Box>
    )
}

// ======================= EXPORT
export default SMAppSalesStatistics
